import {Platform} from 'react-native';
const previewStaticSize = (width: number) => `${width}x140`;
const encasing = Platform.OS === 'web' ? '' : '"';
export const genSpectroGramScript = (
  input: string,
  output: string,
  width: number = 2000,
) => {
  const size = previewStaticSize(width);
  return [
    '-i',
    input,
    '-filter_complex',
    `${encasing}[0:a]aformat=channel_layouts=mono,compand=gain=-1, \
    showwavespic=s=${size}:colors=black,negate[a]; \
    color=black:${size}[c]; \
    [c][a]alphamerge${encasing}`,
    '-vframes',
    '1',
    output,
  ];
};
